import React from 'react';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const CustomPieLabel: React.FC<{ name: string; percent: number; index: number }> = ({
	name,
	percent,
	index,
}) => (
	<text
		x="60%"
		y={`${20 + index * 20}%`}
		fill={COLORS[index % COLORS.length]}
		textAnchor="start"
		dominantBaseline="middle"
		fontWeight="bold"
	>
		{`${name}: ${(percent * 100).toFixed(0)}%`}
	</text>
);

export default CustomPieLabel;
